<template>
    <div>
        <TextBanner>
            Die Pflanze enthält mehr als 100 unterschiedliche Cannabinoide. Die bekanntesten sind <b>THC</b> und <b>CBD</b>, die aber nur in der weiblichen Pflanze ausreichend zu finden sind.
            <br>
            <br>
            Die höchste Konzentration befindet sich hier in den <b>Blüten</b>.

         </TextBanner>

         <InfoBox modalName="020a_THC">
            <template #title>THC</template>
            <!-- <template #subline>Subline in Roman</template> -->
            <template>
                <p>Von den bekannten Haupt-Cannabinoiden hat Delta-9-Tetrahydrocannabinol – kurz THC – die stärkste psychoaktive Wirkung. In der Pflanze liegt es in seiner inaktiven Form vor, als THC-Säure A. Beim Erhitzen wird sie zu THC umgewandelt und kann den Rausch auslösen.</p>
                <p>Deswegen ist das Rauchen von Cannabis die beliebteste Form. Dieser chemische Prozess wird auch beim Backen von Hasch-Brownies in Gang gesetzt.</p>
            <!-- FullscreenImage, lazyload -->
                <FullscreenImage :src="require('../assets/img/020a.jpg')">
                    <figure>
                        <div class="lazy-container bg-dark">
                            <span class="zdf-load-icon"></span>
                            <!-- required (ratio): data-width, data-height -->
                            <img class="img-fluid" data-width="640" data-height="360" v-lazy="require('../assets/img/020a.jpg')" alt="">
                        </div>
                        <figcaption>
                            <div class="legal">&copy; imago</div>
                        </figcaption>
                    </figure>
                </FullscreenImage>
            </template>
        </InfoBox>

        <InfoBox modalName="020b_CBD">
            <template #title>CBD</template>
            <!-- <template #subline>Subline in Roman</template> -->
            <template>
                <p>Cannabidiol (CBD) hat selbst kaum psychoaktive Funktionen, kann aber die Wirkung von THC modifizieren und zum Beispiel unerwünschte Wirkungen abmildern. CBD werden unter anderem <b>beruhigende und entzündungshemmende Eigenschaften</b> zugeschrieben.</p>
            </template>
        </InfoBox>

        <Fallback>
            <picture>
                <source media="(orientation: portrait)" srcset="../assets/img/fallback/fallback_P.jpg">
                <source media="(orientation: landscape)" srcset="../assets/img/fallback/fallback_L.jpg">
                <!-- The img element is required as the last child tag of the picture declaration block. The img element is used to provide backward compatibility for browsers that do not support the picture element, or if none of the source tags matched. -->
                <!--<img class="o-fit o-fit--cover" src="../assets/img/fallback/TextBanner.jpg" alt="">-->
                <img class="o-fit o-fit--cover" src="data:image/gif;base64,R0lGODlhAQABAIAAAP///wAAACH5BAEAAAAALAAAAAABAAEAAAICRAEAOw==" alt="">
            </picture>
        </Fallback>
    </div>
</template>

<script>
    export default {
        name: '020_thccbd',
        babylonState: {
            camera: {
                position: [-0.77, 0.867, 1.25],
                target: [0.325, 4.4, -0.325],
                radiusLimits: [1, 15],

                useAutoRotationBehavior: false,
                idleRotationSpeed: 0.05,
            },

            glasmann: {
                visible: false,
            },

            cannabis_bluete: {
                visible: true,
            },

            cannabis: {
                visible: true,
                
                geo_cannabis: {
                    visible: true,
                    position: [0, 0, 0],
                    scaling: [1, 1, 1],
                    rotation: [0, 0, 0],
                },

                geo_cannabis_bluete: {
                    visible: false,
                    position: [0, 0, 0],
                    scaling: [1, 1, 1],
                    rotation: [0, 0, 0],
                    overlayColor: [250/255, 125/255, 25/255]
                },

                geo_topf: {
                    visible: true,
                    position: [0, 0, 0],
                    scaling: [1, 1, 1],
                    rotation: [0, 0, 0],
                },
            
                geo_thc_label: {
                    visible: true,
                    position: [0, 0, 0],
                    scaling: [1, 1, 1],
                    rotation: [0, 0, 0],
                    renderingGroupId: 2,
                },

                geo_thc_schrift: {
                    visible: true,
                    position: [0, 0, 0],
                    scaling: [1, 1, 1],
                    rotation: [0, 0, 0],
                    renderingGroupId: 2,
                },
            
                geo_cbd_label: {
                    visible: true,
                    position: [0, 0, 0],
                    scaling: [1, 1, 1],
                    rotation: [0, 0, 0],
                    renderingGroupId: 2,
                },

                geo_cbd_schrift: {
                    visible: true,
                    position: [0, 0, 0],
                    scaling: [1, 1, 1],
                    rotation: [0, 0, 0],
                    renderingGroupId: 2,
                },    
                
                geo_label_bluete: {
                    visible: false,
                    position: [0.1, 0.08, 0.1],
                    scaling: [-1, 1, 1],
                    rotation: [0, 1.5708, 0],
                },
            
                geo_label_fasern: {
                    visible: false,
                    position: [0.1, -0.125, -0.1],
                    scaling: [-1, 1, 1],
                    rotation: [0, 1.5708, 0],
                },
            
                geo_label_harz: {
                    visible: false,
                    position: [0.1, 0.11, 0.14],
                    scaling: [-1, 1, 1],
                    rotation: [0, 1.5708, 0],
                },
            
                geo_label_samen: {
                    visible: false,
                    position: [0.1, -0.13, -0.1],
                    scaling: [-1, 1, 1],
                    rotation: [0, 1.5708, 0],
                },
            
                geo_text_bluete: {
                    visible: false,
                    position: [0.1, 0.08, 0.1],
                    scaling: [-1, 1, 1],
                    rotation: [0, 1.5708, 0],
                },
            
                geo_text_fasern: {
                    visible: false,
                    position: [0.1, -0.125, -0.1],
                    scaling: [-1, 1, 1],
                    rotation: [0, 1.5708, 0],
                },
            
                geo_text_harz: {
                    visible: false,
                    position: [0.1, 0.11, 0.14],
                    scaling: [-1, 1, 1],
                    rotation: [0, 1.5708, 0],
                },
            
                geo_text_samen: {
                    visible: false,
                    position: [0.1, -0.13, -0.1],
                    scaling: [-1, 1, 1],
                    rotation: [0, 1.5708, 0],
                },
            },

            vergleich: {
                visible: false,
            },

            hotspots: {

                thc: {
                    visible: true,
                    position: [0.225, 4.675, -0.425],
                    scale: 0.1,
                    renderingGroupId: 1,
                    infoBox: '020a_THC'
                },

                cbd: {
                    visible: true,
                    position: [0.425, 4.675, -0.225],
                    scale: 0.1,
                    renderingGroupId: 1,
                    infoBox: '020b_CBD'
                },
            },
           
        },
        babylonReady: function ()
        {

        },
    }
</script>

<style lang="scss">

</style>